import { TypePolicies } from '@apollo/client'

export const typePolicies: TypePolicies = {
  PerformanceAgreement: {
    fields: {
      actionItemsInfo: {
        merge(_existing: unknown, incoming: unknown) {
          return incoming
        },
      },
    },
  },
  PerformanceReviewProcessParticipationRate: {
    keyFields: false,
  },
  PerformanceReviewProcess: {
    fields: {
      participation: {
        keyArgs: [
          'reviewerIds',
          'agreementCompletionStatus',
          'legalEntityIds',
          'managedByFilter',
          'search',
          'targetEmployeeIds',
          'teamIds',
          'tenureDates',
          'workplaceIds',
        ],
      },
    },
  },
}
